import { FrameCol, FrameRow } from 'common/view/layouts/frames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import CareerModalLayout from './modal/CareerModalLayout';

const CareerHomeTabComponent = () => {
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  return (
    <div className={`tab-pane `} id="e4net-Service" role="tabpanel">
      <h3>{t('career.homeTab1')}</h3>
      <div className="car-process">
        <ul>
          <li>{t('career.homeTab2')}</li>
          <li>{t('career.homeTab3')}</li>
          <li>{t('career.homeTab4')}</li>
          <li>{t('career.homeTab5')}</li>
          <li>
            {t('career.homeTab6')}
            <br />
            {t('career.homeTab7')}
          </li>
          <li>{t('career.homeTab8')}</li>
        </ul>
      </div>
      <FrameRow addClassName="car-formWrap">
        <FrameCol width={4}>
          <div className="title">
            <span></span>
            {t('career.homeTab9')}
          </div>
          <ul className="item">
            <li>
              <i className="fa fa-mortar-board"></i>
              {t('career.homeTab10')}
            </li>
            <li>
              <i className="fa fa-user-circle-o"></i>
              {t('career.homeTab11')}
            </li>
            <li>
              <i className="fa fa-desktop"></i>
              {t('career.homeTab12')}
            </li>
            <li>
              <i className="fa fa-globe"></i>
              {t('career.homeTab13')}
            </li>
            <li>
              <i className="fa fa-language"></i>
              {t('career.homeTab14')}
              <br />
              <small>{t('career.homeTab15')}</small>
            </li>
          </ul>
        </FrameCol>
        <FrameCol width={4}>
          <div className="title">
            <span></span>
            {t('career.homeTab16')}
          </div>
          <ul className="item">
            <li>
              <i className="fa fa-file-text-o"></i>
              {t('career.homeTab17')}
              <br />
              <small>{t('career.homeTab18')}</small>
            </li>
            <li>
              <i className="fa fa-list-alt"></i>
              {t('career.homeTab19')}
            </li>
            <li>
              <i className="fa fa-vcard-o"></i>
              {t('career.homeTab20')}
            </li>
            <li>
              <i className="fa fa-trophy"></i>
              {t('career.homeTab21')}
            </li>
          </ul>
        </FrameCol>
        <FrameCol width={4}>
          <div className="title">
            <span></span>
            {t('career.homeTab22')}
          </div>
          <ul className="item2">
            <li>
              {t('career.homeTab23')}
              <a href="./assets/download/e4net_resume_e4net.doc" download>
                <button type="button" className="btn btn-outline-primary btn-rounded pull-right mgt-10">
                  {t('career.homeTab24')}
                  <i className="fa fa-download5 ml-2"></i>
                </button>
              </a>
            </li>
          </ul>
        </FrameCol>
      </FrameRow>
      <FrameCol addClassName="mt-40" textAlign="text-center">
        <button type="button" className="btn btn-md btn-primary btn-rounded fs-16 px-5" data-toggle="modal" data-target={`#e4net-Service-Modal`} onClick={() => setIsModalOpen(true)}>
          {t('career.homeTab25')}
        </button>
      </FrameCol>
      <CareerModalLayout isOpen={isModalOpen} setIsOpen={setIsModalOpen} modalId={'e4net-Service-Modal'} modalTitleName={t('career.homeTab26')} stat={'home'} />
    </div>
  );
};

export default CareerHomeTabComponent;
